// Check if property detail page
const propertyDetails = document.querySelector('.property-detail');

// Track if the class has been added
let classAdded = false;

// Variable to track the last scroll position
let lastScrollY = window.scrollY;

// Function to check if an element's bottom is in view
function isDetailsBottomInView(el) {
  const rect = el.getBoundingClientRect();
  return rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
}

// Function to handle scroll event
function propertyScroll() {
  const element = document.querySelector('.property-detail .main-container');
  const className = 'bottom-of-details';

  if (isDetailsBottomInView(element)) {
    // Add class if element's bottom is in view
    if (!classAdded) {
      propertyDetails.classList.add(className);
      classAdded = true;
    }
  } else if (classAdded && window.scrollY < lastScrollY) {
    // Remove class if user scrolls back up and element's bottom is out of view
    propertyDetails.classList.remove(className);
    classAdded = false;
  }

  // Update the last scroll position
  lastScrollY = window.scrollY;
}

if (propertyDetails) {
  // Add scroll event listener
  window.addEventListener('scroll', propertyScroll);
}
